module.exports = __webpack_public_path__ + "img/b07.96f32154.png";